import { db } from "./index.js";

export async function addRouteLocation({
  sanitationRouteId,
  lat,
  lon,
  gpsMetadata = null,
}) {
  const currentTimestamp = new Date().toISOString();

  return await db.routeLocations.add({
    sanitation_route_id: sanitationRouteId,
    created_at: currentTimestamp,
    lat,
    lon,
    gps_accuracy_m: gpsMetadata?.gpsAccuracyM ?? null,
    gps_recorded_at: gpsMetadata?.gpsRecordedAt ?? null,
    gps_age_ms: gpsMetadata?.gpsAgeMs ?? null,
    gps_quality: gpsMetadata?.gpsQuality ?? null,
    gps_source: gpsMetadata?.gpsSource ?? null,
    gps_override: gpsMetadata?.gpsOverride ?? false,
  });
}

export async function deleteRouteLocation(routeLocationId) {
  return await db.routeLocations.delete(routeLocationId);
}

export async function getRouteLocations(sanitationRouteId) {
  const locations = await db.routeLocations
    .where("sanitation_route_id")
    .equals(sanitationRouteId)
    .toArray();

  return locations;
}
